var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRoundedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 101"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 9.00002,
    cy: 9.91543,
    r: 6.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1252 2.77045C14.3695 3.48891 15.4046 4.51988 16.128 5.76132C16.8515 7.00276 17.2381 8.41161 17.2497 9.8484C17.2613 11.2852 16.8975 12.7001 16.1942 13.9531C15.4909 15.206 14.4726 16.2536 13.24 16.9921C12.0075 17.7305 10.6034 18.1343 9.16683 18.1634C7.73027 18.1924 6.31102 17.8458 5.04959 17.1578C3.78815 16.4698 2.72827 15.4643 1.97486 14.2408C1.22146 13.0174 0.800663 11.6183 0.754125 10.1822L0.75 9.91495L0.754125 9.64765C0.800328 8.22287 1.21493 6.83437 1.95752 5.61752C2.7001 4.40067 3.74533 3.397 4.99129 2.70435C6.23725 2.01171 7.64143 1.65373 9.06693 1.66531C10.4924 1.6769 11.8906 2.05765 13.1252 2.77045ZM12.0584 7.68167C11.9164 7.53963 11.7273 7.4543 11.5268 7.44169C11.3263 7.42908 11.1281 7.49007 10.9694 7.6132L10.8918 7.68167L8.17509 10.3976L7.10835 9.33167L7.0308 9.2632C6.87206 9.14015 6.67388 9.07924 6.47343 9.09189C6.27298 9.10454 6.08403 9.18987 5.94201 9.33189C5.79998 9.47391 5.71465 9.66286 5.702 9.86331C5.68936 10.0638 5.75027 10.2619 5.87331 10.4207L5.94179 10.4982L7.59181 12.1482L7.66936 12.2167C7.81404 12.329 7.99197 12.3899 8.17509 12.3899C8.35822 12.3899 8.53614 12.329 8.68082 12.2167L8.75837 12.1482L12.0584 8.84822L12.1269 8.77067C12.25 8.61194 12.311 8.41373 12.2984 8.21324C12.2858 8.01274 12.2005 7.82373 12.0584 7.68167Z",
    fill: "#3D8C40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundedCheck);
export default __webpack_public_path__ + "static/media/green-rounded-check.d1d296e5cdd577eda67512ea178e5521.svg";
export { ForwardRef as ReactComponent };